module.exports = __webpack_public_path__ + "static/shareFanAir1BG-924f13c18714619c62fb4bb985317a86.png";